import React from 'react';
import PropTypes from 'prop-types';
import styles from './Surface.module.css';

const Surface = React.forwardRef(
  (
    {
      as: Component = 'div',
      padding = 'md',
      tone = 'default',
      interactive = false,
      className = '',
      children,
      ...props
    },
    ref
  ) => {
  const classes = [
    styles.surface,
    styles[`padding-${padding}`],
    styles[`tone-${tone}`],
    interactive ? styles.interactive : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component ref={ref} className={classes} {...props}>
      {children}
    </Component>
  );
  }
);

Surface.displayName = 'Surface';

Surface.propTypes = {
  as: PropTypes.elementType,
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg', 'xl']),
  tone: PropTypes.oneOf(['default', 'glass', 'accent']),
  interactive: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Surface;
